/**
 * Busca o HTML da próxima página de posts usando a REST API do WordPress.
 *
 * @param {number} nextPage - O número da próxima página a ser buscada.
 * @param {object} queryVars - O objeto com as configurações da query (vindo do PHP).
 * @returns {Promise<string>} O HTML dos novos posts ou uma string vazia em caso de erro.
 */
async function fetchNextPosts(nextPage, queryVars, postTemplateBlocks) {    
    const formData = new FormData();
    formData.append('action', 'wpmundi_load_more');
    formData.append('nonce', window.wpmundi_slider_params?.nonce);
    formData.append('page', nextPage);
    formData.append('query_vars', JSON.stringify(queryVars));
    formData.append('post_template_blocks', JSON.stringify(postTemplateBlocks));

    try {
        const response = await fetch(window.wpmundi_slider_params?.ajax_url, {
            method: 'POST',
            body: formData,
        });
        const result = await response.json();        
        if (result.success && result.data) {
            return result.data;
        } else {
            return '';
        }
    } catch (error) {
        console.error('Erro ao buscar os próximos posts via AJAX:', error);
        return '';
    }
}


export default function initializeDynamicSlider(emblaApi, prevBtn, nextBtn, sliderNode) {

    // --- MUDANÇA 1: Lemos o nosso novo "número mágico" ---
    // Em vez de 'totalPages', agora usamos 'loadablePages' como a autoridade final.
    const pagesToLoad = parseInt(sliderNode.dataset.loadablePages, 10) || 1;
    
    // As outras variáveis que lemos continuam as mesmas.
    const queryVars = JSON.parse(sliderNode.dataset.queryVars || '{}');
    const postTemplateBlocks = JSON.parse(sliderNode.dataset.postTemplate || '[]');
    const container = sliderNode.querySelector('.embla__container');

    

    // Atributos embla para autoplay quando --slides-per-page-large = posts_per_page
    const autoplayEnabled = sliderNode.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(sliderNode.dataset.autoplayDelay, 10) || 3000;
    const initialSlidesCount = emblaApi.slideNodes().length;
    const loopEnabled = sliderNode.dataset.loop === 'true';
    const computedStyle = getComputedStyle(sliderNode);
    const slidesPerPageLarge = parseInt(computedStyle.getPropertyValue('--slides-per-page-large'), 10) || 1;
    const postsPerPage = parseInt(queryVars.posts_per_page, 10) || 1;


    // As variáveis de estado continuam as mesmas.
    let currentPage = 1;
    let isLoading = false;
    
    // --- MUDANÇA 2: A variável de controle agora usa 'pagesToLoad' ---
    let allPagesLoaded = (currentPage >= pagesToLoad);

    // A função de atualizar os botões continua perfeita.
    const updateButtonsState = () => {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = !emblaApi.canScrollPrev();
        nextBtn.disabled = !emblaApi.canScrollNext() && allPagesLoaded;
    };

    // A função de carregar a próxima página.
    const loadNextPage = async () => {
        // A verificação de segurança agora usa 'pagesToLoad' (através da variável 'allPagesLoaded')
        if (isLoading || allPagesLoaded) return;
        isLoading = true;
        
        const nextPage = currentPage + 1;
        const newSlidesHtml = await fetchNextPosts(nextPage, queryVars, postTemplateBlocks);

        

        if (newSlidesHtml) {
            container.insertAdjacentHTML('beforeend', newSlidesHtml);
            currentPage = nextPage;
            
            // --- MUDANÇA 3: Atualizamos o estado usando 'pagesToLoad' ---
            allPagesLoaded = (currentPage >= pagesToLoad);
            
            // emblaApi.reInit();

            allPagesLoaded = (currentPage >= pagesToLoad);
            emblaApi.reInit({ loop: allPagesLoaded && loopEnabled });

            if (typeof sliderNode.updateDots === 'function') {
                sliderNode.updateDots();
            }
        }
        isLoading = false;
    };

    // A configuração dos eventos dos botões continua a mesma.
    prevBtn.addEventListener('click', emblaApi.scrollPrev, false);
    /* nextBtn.addEventListener('click', () => {
        if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
        } else {
            loadNextPage();
        }
    }, false); */
    nextBtn.addEventListener('click', async () => {
    if (emblaApi.canScrollNext()) {
        emblaApi.scrollNext();
        return;
    }
    await loadNextPage();      // espera carregar o novo conteúdo
    emblaApi.scrollNext();     // só então move para o próximo slide
    }, false);


    // A configuração dos eventos do Embla continua a mesma.
    emblaApi.on('select', updateButtonsState);
    emblaApi.on('reInit', updateButtonsState);
    
    // O gatilho de scroll agora também usa 'allPagesLoaded', que por sua vez usa 'pagesToLoad'.
    emblaApi.on('scroll', () => {
        if (emblaApi.scrollProgress() > 0.8 && !isLoading && !allPagesLoaded) {
            loadNextPage();            
        }
    });

    // A chamada inicial para definir o estado dos botões continua a mesma.
    updateButtonsState();   

    // autoplay quando --slides-per-page-large = posts_per_page
    const autoplayShouldTrigger =
        autoplayEnabled &&
        (!allPagesLoaded) &&
        (
            initialSlidesCount === 1 ||
            slidesPerPageLarge === postsPerPage
        );

    if (autoplayShouldTrigger) {
        setTimeout(() => {
            loadNextPage();
        }, autoplayDelay/slidesPerPageLarge);
    }

}  